/**
 * IndxOne Hub — Local license storage
 *
 * Thin persistence layer so the license engine can later be replaced by
 * a remote API without changing page-level UI code.
 */
(function () {
  'use strict';

  const CURRENT_KEY = 'indxone.license.v1';
  const LEGACY_KEY = 'indxone.license.key';

  function readJson(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || 'null');
    } catch {
      return null;
    }
  }

  function writeJson(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  function remove(key) {
    localStorage.removeItem(key);
  }

  window.IndxLicenseStorage = {
    keys: {
      current: CURRENT_KEY,
      legacy: LEGACY_KEY
    },

    read() {
      return readJson(CURRENT_KEY);
    },

    write(record) {
      writeJson(CURRENT_KEY, record);
      if (record?.key) localStorage.setItem(LEGACY_KEY, record.key);
    },

    clear() {
      remove(CURRENT_KEY);
      remove(LEGACY_KEY);
    },

    readLegacyKey() {
      return localStorage.getItem(LEGACY_KEY);
    }
  };
})();
